type Runner<T> = (() => Promise<T>) | Promise<T>

/**
 * Waits for a response from the `runner` up-to the passed
 * `limitMillis`. When the limit elapses before the runner
 * has completed a `void` response is returned.
 */
export function timeLimitedRunner<T>(limitMillis: number, runner: Runner<T>) {
    return Promise.race([
        typeof runner === 'function' ? runner() : Promise.resolve(runner),

        // timeout
        new Promise<void>((res) => {
            setTimeout(() => res(), limitMillis)
        }),
    ])
}
